import { getIdToken, getIdTokenResult, onAuthStateChanged, sendEmailVerification, signOut } from 'firebase/auth'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { auth } from '../firebase'
import Logo from './Logo'
import { toast } from 'react-toastify'
import Search from './Search'
import Zoom from 'react-reveal/Zoom'
import { UserContext } from '../Helpers/user.context'
import Fade from 'react-reveal/Fade'
export default function Header() {
    const [user, setUser] = useState(null)
    const [mobileMenuActive, setMobileMenuActive] = useState(false)
    const userData = useContext(UserContext)
    useEffect(() => {
        onAuthStateChanged(auth, user => {
            if (user) {
                setUser(user)
            } else {
                setUser(null)
            }
        })
    }, [])
    const navigate = useNavigate()
    const AuthButtons = () => {
        return (
            <div className='flex aic' style={{ gap: 20 }}>
                <button className='b1' onClick={() => navigate("/login")}>Login</button>
                <button className='b2' onClick={() => navigate("/signup")}>Sign Up</button>
            </div>
        )
    }
    const mobileNavOut = (rte) => {
        setMobileMenuActive(false)
        navigate(rte)
    }
    const MobileAuthButtons = () => {
        return (
            <div className='flex aic fdc' style={{ gap: 20 }}>
                <button style={{ width: "100%", textAlign: "center" }} className='b3' onClick={() => mobileNavOut("/login")}>Login</button>
                <button style={{ width: "100%", textAlign: "center" }} className='b3' onClick={() => mobileNavOut("/signup")}>Sign Up</button>
            </div>
        )
    }
    const User = () => {
        return (
            <div onClick={() => navigate(`/account/${auth.currentUser.uid}`)} className='flex aic' style={{ gap: 20 }}>
                <h3 className='usrProfileTextHeader'>{user.displayName}</h3>
                {user.photoURL
                    ? <img src={user.photoURL} referrerpolicy="no-referrer" className="pfp" />
                    : <img src={`https://ui-avatars.com/api/?background=0074D9&color=fff&name=${user.displayName}`} referrerPolicy="no-referrer" className="pfp noBorder" alt="Profile picture" />
                }
            </div>
        )
    }
    const MobileUser = () => {
        return (
            <div>
                <div onClick={() => mobileNavOut(`/account/${auth.currentUser.uid}`)} className='flex aic' style={{ gap: 20 }}>
                    {user.photoURL
                        ? <img src={user.photoURL} referrerpolicy="no-referrer" className="pfp" />
                        : <img src={`https://ui-avatars.com/api/?background=0074D9&color=fff&name=${user.displayName}`} referrerPolicy="no-referrer" className="pfp noBorder" alt="Profile picture" />
                    }
                    <h3 className='usrProfileTextHeader'>{user.displayName}</h3>
                    {userData?.isPro
                        ? <p style={{ background: "#0074D9", color: "white", fontWeight: 800, padding: 10, borderRadius: 50 }}>PRO</p>
                        : null
                    }
                    <svg style={{ marginLeft: "auto" }} xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="20px" viewBox="0 0 24 24" width="20px" fill="#000"><g><path d="M0,0h24v24H0V0z" fill="none" /></g><g><polygon points="6.23,20.23 8,22 18,12 8,2 6.23,3.77 14.46,12" /></g></svg>
                </div>
                <div style={{ width: "100%", height: 3, background: "rgba(0,0,0,.1)", margin: "20px 0" }} />
                <div className='flex fdc' style={{ gap: 10 }}>
                    {!userData?.isPro
                        ? <>
                            <button onClick={() => mobileNavOut("/pro")} className="b3 flex aic jcc" style={{ width: "100%", textAlign: "center", gap: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><g><rect fill="none" height="24" width="24" /></g><g><g><path d="M23,11.99l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,11.99l2.44,2.79 l-0.34,3.7l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,11.99z M19.05,13.47l-0.56,0.65l0.08,0.85 l0.18,1.95l-1.9,0.43l-0.84,0.19l-0.44,0.74l-0.99,1.68l-1.78-0.77L12,18.85l-0.79,0.34l-1.78,0.77l-0.99-1.67l-0.44-0.74 l-0.84-0.19l-1.9-0.43l0.18-1.96l0.08-0.85l-0.56-0.65l-1.29-1.47l1.29-1.48l0.56-0.65L5.43,9.01L5.25,7.07l1.9-0.43l0.84-0.19 l0.44-0.74l0.99-1.68l1.78,0.77L12,5.14l0.79-0.34l1.78-0.77l0.99,1.68l0.44,0.74l0.84,0.19l1.9,0.43l-0.18,1.95l-0.08,0.85 l0.56,0.65l1.29,1.47L19.05,13.47z" /><polygon points="10.09,13.75 7.77,11.42 6.29,12.91 10.09,16.72 17.43,9.36 15.95,7.87" /></g></g></svg>
                                Upgrade to PRO
                            </button>
                            <div style={{ width: "100%", height: 3, background: "rgba(0,0,0,.1)", margin: "10px 0" }} />
                        </>
                        : null
                    }
                    <button className='b3' style={{ height: "100%", width: "100%", textAlign: "center" }} onClick={() => mobileNavOut("/create")}>+ Create Poll</button>
                    <button onClick={() => {
                        signOut(auth)
                        mobileNavOut("/home")
                    }} className='b4' style={{ textAlign: "center" }}>Log Out</button>
                </div>
            </div>
        )
    }
    const VerifyHeader = () => {
        const [headerExpanded, setHeaderExpanded] = useState(false)
        useEffect(() => {
            if (headerExpanded) {
                sendEmailVerification(auth.currentUser).then(() => {
                    toast.success("Email sent!")
                }).catch((err) => {
                    toast.error("Something went wrong")
                })
            }
        }, [headerExpanded])
        return (
            <div onClick={() => {
                setHeaderExpanded(true)
            }} style={{ cursor: "pointer", width: "100%", height: 55, background: "#0074D9", textAlign: "center", fontWeight: "bold", color: "white", gap: 10, zIndex: 57482390574839120, position: "fixed" }} className={`verifyHeader flex aic jcc ${headerExpanded ? "headerExpanded" : ""}`}>
                {!headerExpanded
                    ? <>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" /></svg>
                        <p>Your email has not been verified. Click here to verify.</p>
                    </>
                    : <Zoom duration={300} delay={300}>
                        <div>
                            <h1 style={{ margin: 0 }}>We sent a verification email to</h1>
                            <h3 style={{ marginTop: 10 }}>{auth.currentUser.email}</h3>
                            <button className='b4' style={{ marginTop: 20 }} onClick={() => {
                                auth.currentUser.getIdToken(true).then(() => {
                                    window.location.reload()
                                })
                            }}>Click here when verified</button>
                        </div>
                    </Zoom>
                }
            </div>
        )
    }
    const MobileMenu = () => {
        return (
            <Fade duration={200}>
                <div className='bb' style={{ width: "100%", background: " white", position: "fixed", left: 0, bottom: 0, backgroundColor: "white", zIndex: 500000, top: 100, overflow: "hidden", border: "3px solid rgba(0,0,0,.1)", borderTop: "none", padding: 30 }}>
                    {user
                        ? <MobileUser />
                        : <MobileAuthButtons />
                    }
                </div>
            </Fade>
        )
    }
    return (
        <>
            {/* !auth.currentUser || auth.currentUser?.emailVerified */}
            {!auth.currentUser || auth.currentUser?.emailVerified
                ? null
                : <VerifyHeader />
            }
            <div className='view-width bb flex aic jcsb headerContainer' style={{ minHeight: 100, padding: "0 50px", background: "#fff", boxShadow: "0px 0px 10px rgba(0, 116, 217, .2)", position: "fixed", zIndex: 57482390 }}>
                <div className='flex aic' style={{ gap: 0, position: "relative", gap: 20 }}>
                    <Logo navFunc={mobileNavOut} />
                    {userData?.isPro
                        ? <p className='proBadge' style={{ background: "#0074D9", color: "white", fontWeight: 800, padding: 10, borderRadius: 50 }}>PRO</p>
                        : null
                    }
                </div>
                <div className='desktopHeaderItems'>
                    <div className='flex aic' style={{ gap: 30 }}>
                        <Search />
                        <button className='b3' style={{ height: "100%" }} onClick={() => navigate("/create")}>+ Create Poll</button>
                        {user
                            ? <User />
                            : <AuthButtons />
                        }
                    </div>
                </div>
                <div className='mobileHeaderItems'>
                    <svg onClick={() => setMobileMenuActive(!mobileMenuActive)} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" /></svg>
                </div>
            </div>
            {mobileMenuActive
                ? <MobileMenu />
                : null
            }
        </>
    )
}
